'use client'

import { createContext, useContext } from 'react'

export interface LinkProps {
  href: string
  children: React.ReactNode
  className?: string
  ref?: React.Ref<HTMLAnchorElement>
  onClick?: (e: React.MouseEvent) => void
}

function DefaultLink({ href, children, className, ref, onClick }: LinkProps) {
  return (
    <a ref={ref} href={href} className={className} onClick={onClick}>
      {children}
    </a>
  )
}

const LinkContext = createContext<React.ComponentType<LinkProps>>(DefaultLink)

export function LinkProvider({
  value,
  children,
}: {
  value: React.ComponentType<LinkProps>
  children: React.ReactNode
}) {
  return <LinkContext.Provider value={value}>{children}</LinkContext.Provider>
}

export function useLink() {
  return useContext(LinkContext)
}
